<template>
    <div class='contacts'>
        <div class="contact_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li>聯絡我們</li>
                </ul>
            </nav>
        </div>
        <div style="padding: 0 15px;">

            <div class="contact">
                <div class="title">聯絡我們</div>
                <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
                    <form @submit.prevent="handleSubmit(send)">
                        <div class="form_item">
                            <div class="label">*姓名</div>
                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                <input :class="classes" type="text" v-model="form.customer_name" placeholder="請輸入您的姓名">
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form_item">
                            <div class="label">*電子郵件</div>
                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                <input :class="classes" type="email" v-model="form.email" placeholder="請輸入您的電子郵件，例：example@gmail.com">
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form_item">
                            <div class="label">*聯絡電話</div>
                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                <input :class="classes" type="text" v-model="form.phone" placeholder="請輸入聯絡電話">
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="form_item">
                            <div class="label">*問題內容</div>
                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                <textarea :class="classes" rows="5" type="text" v-model="form.content" placeholder="請輸入問題內容"></textarea>
                                <span class="error">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="btn">
                            <button type="submit">送出</button>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>

    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapState } from 'vuex';
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            form: {
                customer_name: '',
                email: '',
                phone: '',
                content: '',
                admin_email: '',
                website_url: ''
            }
        };
    },
    computed: {
        ...mapState('header', ['getnav', 'gethome'])
    },
    watch: {
        gethome: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.email) {
                    this.form.admin_email = newVal.email;
                }
            }
        }
    },
    methods: {
        send() {
            // console.log(1);
            // console.log(this.form);
            this.$swal.fire({
                            allowOutsideClick: false, // 禁止点击外部关闭弹窗
                            customClass: {
                                popup: 'custom-swal'
                            },
                            didOpen: () => {
                                this.$swal.showLoading(); // 显示加载动画
                            }
                        });
            this.$store.dispatch('user/send', this.form).then(res => {
                this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>发送成功</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                            // 设置延时器在一秒后关闭弹窗
                            setTimeout(() => {
                                this.$swal.close();
                            }, 1000); // 1000 毫秒等于 1 秒
                this.form.email = '',
                this.form.customer_name = '',
                this.form.phone = '',
                this.form.content = ''
                this.$refs.observer.reset(); 
            })
        }
    },
    created() {
    },
    mounted() {
        this.form.website_url = window.location.href;
        // this.form.admin_email = 'changlongfeng@yf.support'
    },
}
</script>
<style src="./index.scss" lang='scss' scoped></style>
<!-- function sendMail(data) {
    // console.log(data);
    return axios.post(`https://sapi.yf.support/api/email-service/contact`,data).then(response => {
        // console.log(response);
        return response
    })
} -->